import Styles from "./Styles/main.module.css"
import moduleLayoutStyles from "./Styles/moduleLayout.module.css";
import { Breadcrumbs, Grid, Link } from '@mui/material';
import { useStateValue } from '../../Hooks/stateProvider';
import { useNavigate } from 'react-router-dom';
import { ls } from '../../variables';
import icon1 from "../../images/icon1.svg"
import icon2 from "../../images/icon2.svg"

const ActionType = (props) => {
    const [state, dispatch] = useStateValue();
    const navigate = useNavigate();
    let onHandler = (value) => {
        navigate(value);
    };
    const moduleType = props.type.toUpperCase();
    return (
        <div className={Styles.FullBody}>
            <div className={Styles.navBody}>
                <Grid container spacing={1} display="flex">
                    <Grid item sm={3}>
                        <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                color="inherit"
                                onClick={() => navigate("/app/welcome")}
                            >
                                Welcome
                            </Link>
                            <Link
                                underline="hover"
                                color="inherit"
                            >
                                 {moduleType}
                            </Link>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
            </div>
            <div className={Styles.HeaderBody}>
                <Grid container className={moduleLayoutStyles.mainContent}>
                    <Grid
                        item
                        xs={12}
                        className={moduleLayoutStyles.welcomeContent}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    ></Grid>
                    <Grid item xs={0} sm={2}></Grid>
                    <Grid
                        item
                        lg={4}
                        xs={12}
                        sm={4}
                        md={4}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            dispatch({ type: "uploadType", uploadType: "File" });
                            onHandler("/app/cmmPage")
                               
                        }}
                    >
                        <div className={moduleLayoutStyles.boxContainer}>
                            <img src={icon2} alt="UploadLogo" className={moduleLayoutStyles.moduleImg} />
                            <h3 className={moduleLayoutStyles.moduleName}>Upload File</h3>
                        </div>
                    </Grid>

                    <Grid
                        item
                        lg={4}
                        xs={12}
                        sm={4}
                        md={4}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            dispatch({ type: "uploadType", uploadType: "Form" });
                            onHandler("/app/cmmPage");
                        }}
                    >
                        <div className={moduleLayoutStyles.boxContainer}>
                            <img src={icon1} alt="AlertLogo" className={moduleLayoutStyles.moduleImg} />
                            <h3 className={moduleLayoutStyles.moduleName}> Fill Form </h3>
                        </div>
                    </Grid>
                    <Grid item xs={0} sm={2}></Grid>

                </Grid>
            </div>
        </div>
    )
}

export default ActionType